document.addEventListener('DOMContentLoaded', () => {
  const squaredText = document.querySelectorAll('.c-text--squared');

  if (squaredText) {
    squaredText.forEach(text => {
      const textEl = text;
      const textElInner = textEl.innerHTML;
      const newTextEl = `<span>${textElInner}</span>`;

      textEl.innerHTML = newTextEl;

      textEl.parentElement.classList.add('c-text--squared-wrap');
    });
  }
});



// WEBPACK FOOTER //
// ./src/scripts/modules/text.js